module.exports = __webpack_public_path__ + "media/images/share/dzen-406cb63a9401f23427abbd808cc5c826.svg";